var $2b6e161c9edcf319$exports = {};
const $2b6e161c9edcf319$var$counter = document.querySelector(".counter--js");
const $2b6e161c9edcf319$var$addBtn = document.querySelector(".add--js");
const $2b6e161c9edcf319$var$removeBtn = document.querySelector(".remove--js");
let $2b6e161c9edcf319$var$countNumber = 0;
let $2b6e161c9edcf319$var$key = new Date().toLocaleString().slice(0, 10);
setInterval(()=>{
    if ($2b6e161c9edcf319$var$key !== new Date().toLocaleString().slice(0, 10)) {
        $2b6e161c9edcf319$var$key = new Date().toLocaleString().slice(0, 10);
        $2b6e161c9edcf319$var$countNumber = 0;
    }
}, 60000);
$2b6e161c9edcf319$var$addBtn.addEventListener("click", ()=>{
    const addCount = ++$2b6e161c9edcf319$var$countNumber;
    $2b6e161c9edcf319$var$counter.innerHTML = addCount;
    localStorage.setItem($2b6e161c9edcf319$var$key, $2b6e161c9edcf319$var$countNumber);
});
$2b6e161c9edcf319$var$removeBtn.addEventListener("click", ()=>{
    if ($2b6e161c9edcf319$var$countNumber === 0) $2b6e161c9edcf319$var$counter.innerHTML = 0;
    else {
        const removeCount = --$2b6e161c9edcf319$var$countNumber;
        $2b6e161c9edcf319$var$counter.innerHTML = removeCount;
    }
    localStorage.setItem($2b6e161c9edcf319$var$key, $2b6e161c9edcf319$var$countNumber);
});
if (localStorage.getItem($2b6e161c9edcf319$var$key)) $2b6e161c9edcf319$var$counter.innerHTML = parseInt(localStorage.getItem($2b6e161c9edcf319$var$key));
$2b6e161c9edcf319$var$countNumber = localStorage.getItem($2b6e161c9edcf319$var$key);


//# sourceMappingURL=index.c6ddfdfc.js.map
